export default "__VITE_ASSET__tshkDEvU__"